import { Dispatch } from 'react-redux';
import { AuthActionCreators, IApplicationState } from "../";
import { IBaseResponse } from '@nkr/models/index';

export interface IRecipientForTransplantedList {
    id: number,
    alias: string,
    firstName: string,
    lastName: string,
    birthDate: string,
    transplantDate: string,
    isMicrositePatient: boolean
}

export interface ITransplantData {
    firstName: string,
    lastName: string,
    currentStatus: number,
    birthDate: string,
    transplantDate: string,
    nkrRecipientId?:number,
    dashRegistrationId?:number,
    recipientList: IRecipientForTransplantedList[]
}

export interface IDataForTransplantedResponse {
    data: {
        success: boolean,
        message: string,
        results: ITransplantData
    }
}

export interface INkrRecipientsForMicrositeResponse {
    data: {
        success: boolean,
        message: string,
        results: IRecipientForTransplantedList[]
    }
}

export interface IDashRegistrationForTransplantedList {
    id: number,
    firstName: string,
    lastName: string,
    birthDate: string,
    isFromMicrosite: boolean,
    donatedToMicrositePatient: boolean,
    centerId: number,
    centerAlias: string
}

export interface IDashRegistrationsForTransplantedResponse {
    data: {
        success: boolean,
        message: string,
        results: IDashRegistrationForTransplantedList[]
    }
}

export interface IMarkTransplantedRequest {
    transplantDate: string,
    transplantType: number,
    recipientId: number,
    isNotNkrTransplant: boolean,
    transplantSubType: number,
    hasMedicare: boolean,
    other: string,
    dashRegistrationId: number,
    wasNotFoundInDash: boolean
}

export const ActionCreators = {
    getDataForTransplanted: (micrositeId: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IDataForTransplantedResponse> => {
        let options = {
            url: `${__API__}/microsite/${micrositeId}/transplanted-data`
        };

        try {
            return await dispatch(AuthActionCreators.apiGet(options));
        } catch (error) {
            throw error;
        }
    },

    getNkrRecipientsForMicrosite: (micrositeId: number) => async (dispatch: Dispatch<IApplicationState>): Promise<INkrRecipientsForMicrositeResponse> => {
        let options = {
            url: `${__API__}/microsite/${micrositeId}/nkr-recipients`
        };

        try {
            return await dispatch(AuthActionCreators.apiGet(options));
        } catch (error) {
            throw error;
        }
    },

    getDashRegistrationsForTransplanted: (micrositeId: number, recipientId: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IDashRegistrationsForTransplantedResponse> => {
        let options = {
            url: `${__API__}/microsite/${micrositeId}/dash-transplanted-data?recipientId=${recipientId}`
        };

        try {
            return await dispatch(AuthActionCreators.apiGet(options));
        } catch (error) {
            throw error;
        }
    },
    
}
